var _defs, _rect, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMcMonitoring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#313131;}.cls-2{fill:#fff;stroke-width:.8px;}.cls-2,.cls-3{stroke:#474747;stroke-linecap:round;stroke-linejoin:round;}.cls-3{fill:none;stroke-width:.8px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 23,
    height: 23
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.2,7.9h1.5l2,5.7,2.1-5.7h1.4v7.1h-1.1v-5.2l-2,5.2h-1l-1.9-5.2v5.2h-1.1V7.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.8,12.7c0,.4-.1,.7-.3,1s-.3,.6-.6,.8-.5,.4-.9,.5c-.4,.1-.8,.2-1.2,.2s-1,0-1.4-.3c-.4-.2-.7-.4-1-.7-.3-.3-.5-.7-.6-1.2-.1-.5-.2-1-.2-1.6s0-1.1,.2-1.6c.2-.5,.4-.9,.7-1.2,.3-.3,.6-.6,1-.7,.4-.2,.8-.3,1.3-.3s.8,0,1.2,.2c.3,.1,.6,.3,.8,.5s.4,.5,.5,.8c.1,.3,.2,.6,.3,1l-1.2,.2c0-.2-.1-.5-.2-.6,0-.2-.2-.3-.3-.5-.1-.1-.3-.2-.5-.3-.2,0-.4-.1-.7-.1s-.6,0-.8,.2c-.2,.1-.5,.3-.6,.5s-.3,.5-.4,.9c0,.3-.1,.7-.1,1.1s0,.8,.1,1.1c0,.3,.2,.6,.4,.9s.4,.4,.6,.5,.5,.2,.8,.2,.5,0,.7-.1,.4-.2,.5-.3c.1-.1,.2-.3,.3-.5,0-.2,.1-.4,.2-.6h1.3Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "1.7 6.7 1.7 1.7 6.7 1.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "21.3 6.7 21.3 1.7 16.3 1.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "1.7 16.3 1.7 21.3 6.7 21.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "21.3 16.3 21.3 21.3 16.3 21.3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcMonitoring);
export default __webpack_public_path__ + "static/media/MC-monitoring.621b08310b599dcb9828c917a5c41e23.svg";
export { ForwardRef as ReactComponent };